import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import {
  HttpClient,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AppLoadingService } from '../common/loading.service';
import { of } from 'rxjs/observable/of';

@Injectable()
export class NegotiatorService {
  hostUrl: any = environment.API_BASE_URL;
  portalHostUrl = environment.PORTAL_BASE_URL;
  customerHostUrl = environment.CUSTOMER_BASE_URL;
  public token: string;
  urlToGetAccounts: any = this.hostUrl + 'api/getAccountById';
  urlToGetScript: any = this.hostUrl + 'api/getScripts';
  urlToSaveNotes: any = this.hostUrl + 'api/addNotes';
  urlToGetCalls: any = this.hostUrl + 'api/getCalls';
  urlToGetChats: any = this.hostUrl + 'api/getChats';
  urlToGetPlansByProvider: any = this.hostUrl + 'api/getPlansByProvider';
  urlToUpVote: any = this.hostUrl + 'api/upvotePlan';
  urlToDownVote: any = this.hostUrl + 'api/downvotePlan';
  urlToGetNegoScript: any = this.hostUrl + 'api/getNegotiatorScript';
  urlToRejectBill: any = this.hostUrl + 'api/rejectAccount';
  urlToGetPlansByService: any = this.hostUrl + 'api/getPlansByService';
  urlToGetPdf: string = this.hostUrl + 'api/urlToGetPdf';
  urlToCreatePlan: string = this.hostUrl + 'api/createPlan';
  urlToStorePdf: string = this.hostUrl + 'api/pdfUpload';
  urlToCreateSaving: string = this.hostUrl + 'api/createSaving';
  urlToAddNegotiationDetails: string = this.hostUrl + 'api/addNegotiationDetails';
  urlToCreateNegotiatorCall: string = this.hostUrl + 'api/createNegotiatorCall';
  urlToGetSignedURL: string = this.hostUrl + 'api/getSignedURL';
  urlToGetNegotiatorStats: string = this.hostUrl + 'api/getNegotiatorStats';
  urlToGetUpdateSaving: string = this.hostUrl + 'api/updateSaving';
  urlToUpdateAccount: string = this.hostUrl + 'api/updateAccount';
  urlToSubmitQaSavings: string = this.hostUrl + 'api/qaSubmittedSaving';
  urlToAskMoreInfoForSavings: string = this.hostUrl + 'api/qaAskedMoreInfo';
  urlToGetNegotiationDetails: string = this.hostUrl + 'api/getNegotiationDetails';
  urlToGetLatestNegotiation: string = this.hostUrl + 'api/getLatestNegotiation';
  urlToSendNotice: string = this.portalHostUrl + 'notices/create';
  urlToGetNotice: string = this.portalHostUrl + 'notices';
  urlToArchiveNotice: string = this.portalHostUrl + 'notices/archive';
  urlToScoreNow: string = this.portalHostUrl + 'score/create';
  urlToMakeCall: string = this.portalHostUrl + 'ring-central/dial';
  urlToUpdateCustomerAccount: string = this.customerHostUrl + 'accounts/updateAccount';

  constructor(private _http: HttpClient) {}

  fetchProviderPlans(provider_id: string): Observable<any> {
    return this._http
      .get(this.urlToGetPlansByProvider + '/' + provider_id)
      .map((res: Response) => res);
  }
  fetchServicePlans(service: string): Observable<any> {
    return this._http.get(this.urlToGetPlansByService + '/' + service).map((res: Response) => res);
  }

  fetchNegoScript(): Observable<any> {
    return this._http.get(this.urlToGetNegoScript).map((res: Response) => res);
  }

  saveNotes(notes: any): Observable<any> {
    return this._http.post(this.urlToSaveNotes, notes).map((res: Response) => res);
  }
  uploadPdf(data: any): Observable<any> {
    return this._http.post(this.urlToGetPdf, data).map((res: Response) => res);
  }
  fetchAccounts(user_id: string): Observable<any> {
    return this._http.get(this.urlToGetAccounts + '/' + user_id).map((res: Response) => res);
  }

  fetchCalls(phone: string): Observable<any> {
    return this._http.post(this.urlToGetCalls, { phone: phone }).map((res: Response) => res);
  }

  fetchScript(user_id: string): Observable<any> {
    return this._http.post(this.urlToGetScript, { cust_id: user_id }).map((res: Response) => res);
  }

  downVotePlan(data): Observable<any> {
    return this._http.post(this.urlToDownVote, data).map((res: Response) => res);
  }
  upVotePlan(data): Observable<any> {
    return this._http.post(this.urlToUpVote, data).map((res: Response) => res);
  }
  rejectBill(data): Observable<any> {
    return this._http.post(this.urlToRejectBill, data).map((res: Response) => res);
  }
  createPlan(data: any): Observable<any> {
    return this._http.post(this.urlToCreatePlan, data).map((res: Response) => res);
  }
  closeAccount(data: any): Observable<any> {
    return this._http.post(this.urlToCreateSaving, data).map((res: Response) => res);
  }
  addNegotiationDetails(data: any): Observable<any> {
    return this._http.post(this.urlToAddNegotiationDetails, data).map((res: Response) => res);
  }
  updateAccount(data: any): Observable<any> {
    return this._http.post(this.urlToGetUpdateSaving, data).map((res: Response) => res);
  } //TODO Rename this
  updateCustomerAccount(data: any): Observable<any> {
    return this._http.post(this.urlToUpdateCustomerAccount, data).map((res: Response) => res);
  }
  uploadPDF(data: any): Observable<any> {
    return this._http.post(this.urlToStorePdf, data).map((res: Response) => res);
  }
  createNegotiatorCall(data: any): Observable<any> {
    return this._http.post(this.urlToCreateNegotiatorCall, data).map((res: Response) => res);
  }
  getNegotiatorStats(data: any): Observable<any> {
    const API_RESPONSE = JSON.parse(localStorage.getItem('API_RESPONSE_getNegotiatorStats'));
    if (API_RESPONSE) {
      console.log('Cache Hit - getNegotiatorStats');
      return of(API_RESPONSE); // return cached values
    }
    return this._http.post(this.urlToGetNegotiatorStats, data).map((res: Response) => {
      localStorage.setItem('API_RESPONSE_getNegotiatorStats', JSON.stringify(res));
      return res;
    });
  }
  getSignedURL(pdfFileName: string): Observable<any> {
    return this._http
      .get(this.urlToGetSignedURL + '?filename=' + pdfFileName)
      .map((res: Response) => res);
  }

  getSignedFile(signedUrl: string): Observable<any> {
    return this._http.get(signedUrl, { responseType: 'blob' }).map((res: any) => res);
  }
  submitQaSaving(data: any): Observable<any> {
    return this._http.post(this.urlToSubmitQaSavings, data).map((res: Response) => res);
  }
  qaAskedMoreInfo(data: any): Observable<any> {
    return this._http.post(this.urlToAskMoreInfoForSavings, data).map((res: Response) => res);
  }
  getNegotiationDetails(data: any): Observable<any> {
    return this._http.post(this.urlToGetNegotiationDetails, data).map((res: Response) => res);
  }
  getLatestNegotiation(data: any): Observable<any> {
    return this._http.post(this.urlToGetLatestNegotiation, data).map((res: Response) => res);
  }
  sendNotice(data: any): Observable<any> {
    return this._http.post(this.urlToSendNotice, data).map((res: Response) => res);
  }
  getNotices(data: any): Observable<any> {
    return this._http.get(this.urlToGetNotice + data.queryUrl).map((res: Response) => res);
  }
  archiveNotice(data: any): Observable<any> {
    return this._http.post(this.urlToArchiveNotice, data).map((res: Response) => res);
  }
  submitScore(data: any): Observable<any> {
    return this._http.post(this.urlToScoreNow, data).map((res: Response) => res);
  }
  getScore(data: any): Observable<any> {
    const url = `${this.portalHostUrl}score/${data.url}`;
    return this._http.get(url).map((res: Response) => res);
  }
  getSuperNegoDashboard(data: any): Observable<any> {
    const url = `${this.portalHostUrl}dashboard/superNegotiator/${data.url}`;
    return this._http.get(url).map((res: Response) => res);
  }
  getNegoManagerDashboard(data: any): Observable<any> {
    const url = `${this.portalHostUrl}dashboard/negotiationManager/${data.url}`;
    return this._http.get(url).map((res: Response) => res);
  }
  makeCallToProvider(data: any): Observable<any> {
    return this._http.post(this.urlToMakeCall, data).map((res: Response) => res);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/main/negotiator.service.ts